import { render } from "./property-estimateitem.vue?vue&type=template&id=b45f75ee"
import script from "./property-estimateitem.js?vue&type=script&lang=js"
export * from "./property-estimateitem.js?vue&type=script&lang=js"

import exportComponent from "/builds/movoto/frontend/consumer-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__